module.exports = __webpack_public_path__ + "img/ic-padlock.8369437d.svg";